import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import $ from 'jquery';
import { Row,Col, Card, Form, Button, InputGroup, Modal, Table} from 'react-bootstrap';
import {Helmet} from "react-helmet";
import {
  getls, integerIndMobile, lettersOnly, integerAadhar, integerKeyPress, decimalKeyPress, upperCase, momentDate
} from '../../../utils';
import {Api} from '../../../utils/Variables';
import axios from 'axios';
import { message, Tooltip, Spin, Switch,}  from 'antd';

import PsContext from '../../context/PsContext';

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 8 },
};

class AddCollectionNewEntry extends Component{
	
	static contextType = PsContext;
	
	constructor(props){
		super(props);
		this.state = {
			showLoader: false,
			showCustomerSerach: false,
			isMorning: true,
			customers: [],
			customerView: [],
			selectedCustomer: [],
			totalLitters: '',
			totalWeight: '',
			rate: '',
			totalAmount: '',
			totalFat: '',
			totalLr: '',
			totalSnf: '',
			i__codeNew: '',
			i__weightNew: '',
			i__fatNew: '',
			i__clrNew: '',
			enteredData: [],
		}
		
		this.handleShiftChange = this.handleShiftChange.bind(this);
		this.handleCustomerSearchClick = this.handleCustomerSearchClick.bind(this);
		this.handleCustomerSearchClose = this.handleCustomerSearchClose.bind(this);
		this.handleFormSubmit = this.handleFormSubmit.bind(this);
		this.handleCustomerSelect = this.handleCustomerSelect.bind(this);
		this.handleWeightChange = this.handleWeightChange.bind(this);
		this.handleFatChange = this.handleFatChange.bind(this);
		this.handleLrChange = this.handleLrChange.bind(this);
		this.handleSearch = this.handleSearch.bind(this);
		this.addButtonPress = this.addButtonPress.bind(this);
	}
	
	resetState(){
		this.setState({
			selectedCustomer: [],
			totalLitters: '',
			totalWeight: '',
			rate: '',
			totalAmount: '',
			totalFat: '',
			totalLr: '',
			totalSnf: '',
			enteredData: [],
		});
	}
	
	componentDidMount(){
		
		this.context.updateHeader({
			top: false,
			title: 'Collection Entry',
			back: true,
		});
		/* this.setState({
			isMorning: parseInt(momentDate((new Date()),'H'))>parseInt('12') ? false : true,
		}); */
		this.state.isMorning = parseInt(momentDate((new Date()),'H'))>parseInt('12') ? false : true;
		this.loadData();
	}
	
	componentWillUnmount(){
		
		this.context.updateHeader({top: false});		
	}
	
	loadData(){
		try{
			this.setState({
				dataView: [],
				dataList: [],
				showLoader: true,
			});
			axios.get(Api.Url+'v1/customers?api='+this.context.state.api).then(res=>{
				if(res['data'].status=='1'){
					this.setState({
						customers: res['data'].data,				
						customerView: res['data'].data,				
					});
				}
				this.setState({showLoader: false});
			});
		}
		catch(error){
			this.setState({showLoader: false});
		}
	}
	
	handleCustomerSearchClick(){
		this.setState({
			showCustomerSerach: true
		});
	}
	
	handleCustomerSearchClose(){
		this.setState({
			showCustomerSerach: false,
			customerView: this.state.customers,
		});
	}
	
	handleFormSubmit(e){
		e.preventDefault();
		try{
			
			if(Object.keys(this.state.enteredData).length<1){
				message.error('Enter Correct data');
				return;
			}
			
			if(!window.confirm('Do you want to save?')){
				return;
			}
			
			this.setState({showLoader: true});
			 axios.post(Api.Url+'v1/collection/new', $("#frmCollection_Entry").serialize()).then(res=>{
				if(res['data'].status=='1'){
					document.getElementById("frmCollection_Entry").reset();
					message.success(res['data'].message || 'Success');
					this.setState({showLoader: false});
					this.resetState();
				}	
				else{
					message.error(res['data'].message || 'Error');
					this.setState({showLoader: false});
				}
			 });
			
		}
		catch(error){
			this.setState({showLoader: false});
		}
	}
	
	
	
	handleShiftChange(e){
	
		this.setState({
			isMorning: e,
		});
	}
	
	handleCustomerSelect(item){
		
		this.setState({
			selectedCustomer: item,
			showCustomerSerach: false,
		});
		
	}
	
	handleWeightChange(e){
		try{
			var weight = e.target.value;
			var lit = (parseFloat(weight)/ 1.03).toFixed(1);
			
			this.setState({
				totalWeight: weight,
				totalLitters: lit,
			});
			
			this.updateRate();
		}
		catch(error){}
	}
	
	handleFatChange(e){
		
		this.setState({
			totalFat: e.target.value,
		});
		this.state.totalFat = e.target.value;
		//console.log(this.state.totalFat);
		this.calculateSnf();
		
	}
	
	handleLrChange(e){
		
		this.setState({
			totalLr: e.target.value,
		});
		this.state.totalLr = e.target.value;
		//console.log(this.state.totalLr);
		this.calculateSnf();
		
	}
	
	calculateSnf(){
		try{
			
			var snf = ( (parseFloat(this.state.totalLr)/4) + (0.20 * parseFloat(this.state.totalFat)) + 0.36).toFixed(2);
			this.setState({
				totalSnf: snf
			});
			
			this.updateRate();
		}
		catch(error){ console.log(error); }
	}
	
	updateRate(){ 
		try{
			var ts = this.context.state.company.ts_value;
			/* console.log('Fat : '+(parseFloat(this.state.totalFat)));
			console.log('Snf : '+(parseFloat(this.state.totalSnf)));
			console.log('Ts : '+(parseFloat(ts)));
			console.log('------------------------'); */
			var rate = ( (parseFloat(this.state.totalFat) + parseFloat(this.state.totalSnf)) * parseFloat(ts)).toFixed(2);
			rate = (parseFloat(rate)/100).toFixed(2);
			var total = (parseFloat(rate) * parseFloat(this.state.totalLitters)).toFixed(2);
			
			this.setState({
				rate: rate,
				totalAmount: total,
			});
			
		}
		catch(error){ 
			console.log(error);
		}
	}
	
	handleSearch(e){
		try{
			var d = this.state.customers;
			var v = upperCase(e.target.value);
			var s = d.filter(function(obj){
				return( (upperCase(obj.customer_name).indexOf(v)>-1) || 
				(upperCase(obj.customer_address).indexOf(v)>-1) || 
				(upperCase(obj.customer_mobile).indexOf(v)>-1) );
			});
			
			this.setState({customerView:s});
		}
		catch(error){}
	}
	
	addButtonPress(){
		try{
			
			var cs = this.state.customers;
			var s = this.state;
			
			var index = cs.findIndex(function(obj){
				return(upperCase(obj.customer_code) == upperCase(s.i__codeNew));
			});
			
			if(index == -1){
				message.error('Incorrect Customer Code');
				return;
			}
			var cus = cs[index];
			
			if(s.i__codeNew.length<1){
				message.error('Enter Code');
				return;
			}
			if(s.i__weightNew.length<1){
				message.error('Enter Weight');
				return;
			}
			if(s.i__fatNew.length<1){
				message.error('Enter Fat');
				return;
			}
			if(s.i__clrNew.length<1){
				message.error('Enter CLR');
				return;
			}
			
			var weight = s.i__weightNew;
			var lit = (parseFloat(weight)/ 1.03).toFixed(1);
			var fat = s.i__fatNew;
			
			var snf = ( (parseFloat(s.i__clrNew)/4) + (0.20 * parseFloat(fat)) + 0.36).toFixed(2);
			var ts = this.context.state.company.ts_value;
			var rate = ( (parseFloat(fat) + parseFloat(snf)) * parseFloat(ts)).toFixed(2);
			rate = (parseFloat(rate)/100).toFixed(2);
			var total = (parseFloat(rate) * parseFloat(lit)).toFixed(2);
			
			var ed = this.state.enteredData;
			var newEd = {
				cid: cus.id,
				code: s.i__codeNew,
				weight: weight,
				litters: lit,
				fat: fat,
				clr: s.i__clrNew,
				snf: snf,
				rate: rate,
				total: total,				
			};
			ed.push(newEd);
			this.setState({
				enteredData: ed,
				i__codeNew: '',
				i__weightNew: '',
				i__fatNew: '',
				i__clrNew: '',
			});
			
			$("#i__codeNew").focus();
			
		}
		catch(error){ 
			console.log(error);
		}
	}
	
	handleNewInputChange(e){
		this.setState({
			[e.target.name]: e.target.value,
		});
	}
	
	calculateTotal(fieldName){
		try{
			var d = this.state.enteredData;
			var total = 0;
			d.map((item,i)=>{
				total = parseFloat(total) + parseFloat(item[fieldName]);
			});
			return parseFloat(total).toFixed(2);
		}
		catch(er){
			
		}
	}
	
	getAvg(field){
		try{
			var total = this.calculateTotal(field);
			var size = Object.keys(this.state.enteredData).length;
			
			var avg = parseFloat(total) / parseFloat(size);
			
			return parseFloat(avg).toFixed(2);
		}
		catch(error){ }
	}
	
	render(){

		return(
			<div className="container" >
			<div data-aos="fade" >
				
				<Spin spinning={this.state.showLoader} >
				
						<form
							action=""
							method="post"
							encType="multipart/form-data"
							id="frmCollection_Entry"
							onSubmit={this.handleFormSubmit}
						>
						
						<input type="hidden" name="api" value={this.context.state.api} />
						<input type="hidden" name="i__shift" value={this.state.isMorning ? 'Morning' : 'Evening'} />
						<input type="hidden" name="i__enteredData" value={JSON.stringify(this.state.enteredData)} />
						<input type="hidden" name="i__ts" value={this.context.state.company.ts_value} />
						
						<Card className="mb-10" >
							<Card.Body>
								<Row>
									<Col md={6} >
										<Row>
											<Col md={3} >
												<label>Shift</label>
											</Col>
											<Col md={9} >
												<Switch 
													checkedChildren="Morning"
													unCheckedChildren="Evening" 
													defaultChecked={this.state.isMorning}
													onChange={this.handleShiftChange} 
												/>
											</Col>
										</Row>
									</Col>
									<Col md={6} >
										<Row>
											<Col md={3} >
												<label>Date</label>
											</Col>
											<Col md={9} >
												<Form.Control
													type="date"
													name="i__entrtyDate"
													size="sm"
													defaultValue={momentDate((new Date()),'YYYY-MM-DD')}
													required
												/>
											</Col>
										</Row>
									</Col>
								</Row>
							</Card.Body>
						</Card>
						
						<Card className="mb-10" >
							<Card.Body>
								<Row>
									<Col md={2} >
										<div className="input-group input-group-sm">
										  <div className="input-group-prepend">
											<span className="input-group-text" id="basic-addon1">Code</span>
										  </div>
										  <input type="text" 
												onKeyPress={decimalKeyPress} 
												id="i__codeNew" name="i__codeNew" 
												onChange={this.handleNewInputChange.bind(this)} 
												value={this.state.i__codeNew} 
												className="form-control form-control-sm" 
											/>
										</div>
									</Col>
									
									<Col md={2} >
										<div className="input-group input-group-sm">
										  <div className="input-group-prepend">
											<span className="input-group-text" id="basic-addon1">Weight</span>
										  </div>
										  <input type="text" 
												onKeyPress={decimalKeyPress} 
												id="i__weightNew" name="i__weightNew" 
												onChange={this.handleNewInputChange.bind(this)}  
												value={this.state.i__weightNew}  
												className="form-control form-control-sm"  
											/>
										</div>
									</Col>
									
									<Col md={2} >
										<div className="input-group input-group-sm">
										  <div className="input-group-prepend">
											<span className="input-group-text" id="basic-addon1">Fat</span>
										  </div>
										  <input type="text" 
												onKeyPress={decimalKeyPress} 
												id="i__fatNew" name="i__fatNew"  
												onChange={this.handleNewInputChange.bind(this)} 
												value={this.state.i__fatNew}  
												className="form-control form-control-sm"  
											/>
										</div>
									</Col>
									
									<Col md={2} >
										<div className="input-group input-group-sm">
										  <div className="input-group-prepend">
											<span className="input-group-text" id="basic-addon1">Clr</span>
										  </div>
										  	<input type="text" 
												onKeyPress={decimalKeyPress} 
												id="i__clrNew" name="i__clrNew" 
												onChange={this.handleNewInputChange.bind(this)} 
												value={this.state.i__clrNew}  
												className="form-control form-control-sm"  
											/>
										</div>
									</Col>
									
									<Col md={2} >
										<button type="button" 
											onClick={this.addButtonPress} 
											className="btn btn-sm btn-block" 
										>
											Add
										</button>
									</Col>
								</Row>
							</Card.Body>
						</Card>
						
						<Card>
							<Card.Body className="py-5 px-5" >
								<Table className="table table-sm table-bordered font-14" >
									<thead className="thead-light" >
										<tr>
											<th>S.No</th>
											<th>Code</th>
											<th>Weight</th>
											<th>Litters</th>
											<th>Fat (%)</th>
											<th>Clr (%)</th>
											<th>SNF (%)</th>
											<th>Rate</th>
											<th>Total</th>
										</tr>
									</thead>
									<tbody>
									{this.state.enteredData.map((item,i)=>{
										return <tr key={i} >
											<td>{i+1}</td>
											<td>{item.code}</td>
											<td align="right" >{item.weight}</td>
											<td align="right" >{item.litters}</td>
											<td align="right" >{item.fat}</td>
											<td align="right" >{item.clr}</td>
											<td align="right" >{item.snf}</td>
											<td align="right" >{item.rate}</td>
											<td align="right" >{item.total}</td>
										</tr>;
									})
									}
									<tr style={{fontWeight: '600'}}>
										<td colSpan="2" align="right" >Total : </td>
										<td align="right" >{this.calculateTotal('weight')}</td>
										<td align="right" >{this.calculateTotal('litters')}</td>
										<td align="right" >Avg: &nbsp; {this.getAvg('fat')}</td>
										<td></td>
										<td align="right" >Avg: &nbsp; {this.getAvg('snf')}</td>
										<td align="right"  >{this.calculateTotal('rate')}</td>
										<td align="right" >{this.calculateTotal('total')}</td>
									</tr>
									</tbody>
								</Table>
								
							</Card.Body>
						</Card>
						
						{/*<Row className="mt-15" >
							<Col xs={3} >
								<label className="font-13" >
									Code
								</label>
							</Col>
							<Col xs={9} >
								<InputGroup className="mb-3" size="" >
									<Form.Control
										type="number"
										name="i__customerCode"
										size="sm"
										className="no-arrow"
										defaultValue={this.state.selectedCustomer.customer_code}
										required
									/>
									<InputGroup.Prepend>
									  <Button
										type="button"
										size="sm"
										variant="primary"
										style={{height: '36px'}} 
										onClick={this.handleCustomerSearchClick} 
									  >
										<i className="icofont-search"></i>
									  </Button>
									</InputGroup.Prepend>
								  </InputGroup>
							</Col>
						</Row>
							
						<Row className="mt-12"  >
							<Col xs={3} >
								<label className="font-13" >
									Weight
								</label>
							</Col>
							<Col xs={9} >
								<Form.Control
									type="number"
									name="i__weight"
									step="any"
									size="sm"
									value={this.state.totalWeight}
									onChange={this.handleWeightChange}
									required
								/>
							</Col>
						</Row>
						
						<Row className="mt-15"  >
							<Col xs={3} >
								<label className="font-13" >
									Litters
								</label>
							</Col>
							<Col xs={9} >
								<Form.Control
									type="number"
									name="i__litters"
									value={this.state.totalLitters}
									step="any"
									size="sm"
									required
								/>
							</Col>
						</Row>
						
						<Row className="mt-15"  >
							<Col xs={3} >
								<label className="font-13" >
									Fat (%)
								</label>
							</Col>
							<Col xs={9} >
								<Form.Control
									type="text"
									name="i__fat"
									step="any"
									size="sm"
									value={this.state.totalFat}
									onChange={this.handleFatChange}
									onKeyPress={decimalKeyPress}
									required
								/>
							</Col>
						</Row>
						
						<Row className="mt-15"  >
							<Col xs={3} >
								<label className="font-13" >
									LR (%)
								</label>
							</Col>
							<Col xs={9} >
								<Form.Control
									type="text"
									name="i__lr"
									step="any"
									size="sm"
									value={this.state.totalLr}
									onChange={this.handleLrChange}
									onKeyPress={decimalKeyPress}
									required
								/>
							</Col>
						</Row>
						
						<Row className="mt-15"  >
							<Col xs={3} >
								<label className="font-13" >
									SNF (%)
								</label>
							</Col>
							<Col xs={9} >
								<Form.Control
									type="text"
									name="i__snf"
									step="any"
									size="sm"
									value={this.state.totalSnf}
									required
								/>
							</Col>
						</Row>
						
						<Row className="mt-15"  >
							<Col xs={3} >
								<label className="font-13" >
									Rate
								</label>
							</Col>
							<Col xs={9} >
								<Form.Control
									type="text"
									name="i__rate"
									step="any"
									size="sm"
									value={this.state.rate}
									required
								/>
							</Col>
						</Row>
						
						<Row className="mt-15"  >
							<Col xs={3} >
								<label className="font-13" >
									Total
								</label>
							</Col>
							<Col xs={9} >
								<Form.Control
									type="text"
									name="i__total"
									step="any"
									size="sm"
									value={this.state.totalAmount}
									required
								/>
							</Col>
						</Row>
						
						*/}
						
						<Row className="mt-15" >						
							<Col md={12} >
								<Button
									type="submit"
									variant="success"
									size="md"
									block
									style={{width: '100%'}}
								>
									Save Data
								</Button>
							</Col>
						</Row>
							
						</form>
				
				</Spin>
				
				<Modal show={this.state.showCustomerSerach} onHide={this.handleCustomerSearchClose} >
					<Modal.Header closeButton >
						Search
					</Modal.Header>
					<Modal.Body>
						<Form.Control
							size="sm"
							type="text"
							placeholder="Search by Name..."
							className="mb-10"
							onChange={this.handleSearch} 
						/>
						
						{this.state.customerView.map((item,i)=>{
							return <div className="card settings-card">
								<div className="card-body">
								  <div className="single-settings d-flex align-items-center justify-content-between">
									<div className="title">
										<div className="font-weight-600" >{item.customer_name}</div>
										<span>{item.customer_address}</span>
									</div>
									<div className="data-content" onClick={this.handleCustomerSelect.bind(this,item)} >
									  <div className="font-20"  >
										<i className="icofont-arrow-right"></i>
									  </div>
									</div>
								  </div>
								</div>
							  </div>;
						})
						}
					</Modal.Body>
				</Modal>
				 
			</div>
			</div>
		);
	}
	
}
export default AddCollectionNewEntry;
